import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule, DataService, FgMenuService, ThemingService, Configurations } from 'fg-library';
import { FgClientMainNavComponent } from './components/main-nav/main-nav.component';
import { FgClientToolbarComponent } from './components/toolbar/toolbar.component';
import { FgClientTopNavComponent } from './components/top-nav/top-nav.component';
import { ClientSidenavComponent } from './components/sidenav/sidenav.component';
import { FgHoverDropDownTopnavDirective } from './components/directive/fg-hover-dropdown.directive';
import { ClientTopNavMenuItemComponent } from './components/top-nav/menu-item/top-nav-menu-item.component';
// import { SettingsPanelComponent } from '../settings-panel/settings-panel.component';
import { FgClientRoundedTopNavComponent } from './components/top-nav/rounded-top-nav/rounded-top-nav.component';
import { MegaMenuItemComponent } from './components/top-nav/rounded-top-nav/megaMenu/fg-mega-menu';

@NgModule({
  declarations: [
    FgClientMainNavComponent,
    FgClientToolbarComponent,
    FgClientTopNavComponent,
    ClientSidenavComponent,
    FgHoverDropDownTopnavDirective,
    ClientTopNavMenuItemComponent,
    FgClientRoundedTopNavComponent,
    MegaMenuItemComponent
  ],
  exports: [
    FgClientMainNavComponent,
    FgClientToolbarComponent,
    FgHoverDropDownTopnavDirective
  ],
  imports: [
    SharedModule,
    RouterModule
  ],
  providers: [
    DataService,
    FgMenuService,
    ThemingService,
    Configurations
  ]
})
export class FgClientSharedModule { }